import contactForm from '../modules/contact-form';

const initialize = () => {
    const contactFormInstance = new contactForm();
    
    contactFormInstance.fill();
};

export default initialize;
